import './index.scss';
import React, {FunctionComponent, useMemo} from "react";
import {Box, BoxProps, Button, CircularProgress, Typography} from "@mui/material";
import {ReactComponent as SaveIcon} from '../../../assets/svgs/save-rollback/check.svg'
import {ReactComponent as RollbackIcon} from '../../../assets/svgs/save-rollback/cancel.svg'
import UIUtils from "../../utils";


export interface SaveOrRollbackProps {
    onSave: React.MouseEventHandler,
    onRollback: React.MouseEventHandler,
    layout: 'column' | 'row',
    loading?: boolean,
    show?: boolean,
    showSave?: boolean,
    showRollback?: boolean,
    showText?: boolean,
    showSaveText?: boolean,
    showRollbackText?: boolean,
    saveText?: string,
    rollbackText?: string,
    sx?: BoxProps['sx'],
}

const SaveOrRollback: FunctionComponent<SaveOrRollbackProps> = (props) => {
    const showSave = useMemo(() => props.showSave ?? props.show ?? true, [props.show, props.showSave])
    const showRollback = useMemo(() => props.showRollback ?? props.show ?? true, [props.show, props.showRollback])

    const showSaveText = useMemo(() => showSave && props.showText && (props.showSaveText ?? true), [props.showSaveText, props.showText, showSave])
    const showRollbackText = useMemo(() => showRollback && props.showText && (props.showRollbackText ?? true), [props.showRollbackText, props.showText, showRollback])

    const saveText = useMemo(() => props.saveText ?? "Save", [props.saveText]);
    const rollbackText = useMemo(() => props.rollbackText ?? "Cancel", [props.rollbackText]);

    return (
        <>
            <Box
                className={'save-rollback'}
                sx={(theme) => ({
                    display: 'flex',
                    flexDirection: props.layout,
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1.5,
                    ...(UIUtils.invokeSx(props.sx, theme) as any),
                })}
            >
                {
                    showSave &&
                    <Button
                        color={'primary'}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 0.5,
                            ...(!showSaveText && {minWidth: 0, padding: 0})
                        }}
                        onClick={props.onSave}
                        disabled={props.loading}
                    >
                        {
                            !props.loading &&
                            <SaveIcon className={'check-icon'}/>
                        }
                        {
                            props.loading &&
                            <CircularProgress size={10} color={'primary'}/>
                        }
                        {
                            showSaveText &&
                            <Typography variant={'body2'} color={'primary'} fontWeight={600}>
                                {
                                    !props.loading &&
                                    saveText
                                }
                                {
                                    props.loading &&
                                    "loading..."
                                }
                            </Typography>
                        }
                    </Button>
                }
                {
                    showRollback &&
                    <Button
                        color={'error'}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 0.5,
                            ...(!showRollbackText && {minWidth: 0, padding: 0})
                        }}
                        onClick={props.onRollback}
                        disabled={props.loading}
                    >
                        {
                            !props.loading &&
                            <RollbackIcon className={'rollback-icon'}/>
                        }
                        {
                            props.loading &&
                            <CircularProgress size={10} color={'error'}/>
                        }
                        {
                            showRollbackText &&
                            <Typography variant={'body2'} color={'error'} fontWeight={600}>
                                {
                                    !props.loading &&
                                    rollbackText
                                }
                                {
                                    props.loading &&
                                    "loading..."
                                }
                            </Typography>
                        }
                    </Button>
                }
            </Box>
        </>
    );
}

export default SaveOrRollback;
